import { Columns } from '@/types';

interface ColumnDimensions {
  width: number | undefined;
  minWidth: number;
  padding: string;
}

// Minimum widths in pixels for different column types
const MIN_WIDTH_POI_ICONS = 250;
const MIN_WIDTH_VIEW_3D = 200;
const MIN_WIDTH_TAG_NAME = 200;
const MIN_WIDTH_DEFAULT = 320;

// Threshold for when columns should expand to fill available space
const EXPAND_THRESHOLD = 8;

export const getColumnDimensions = (column: Columns, totalColumns: number): ColumnDimensions => {
  const basePadding = '1.2rem';
  const shouldExpand = totalColumns <= EXPAND_THRESHOLD;

  // POI Icons column
  if (column.displayConfig?.type === 'POI_ICONS') {
    return {
      width: shouldExpand ? undefined : MIN_WIDTH_POI_ICONS,
      minWidth: MIN_WIDTH_POI_ICONS,
      padding: basePadding,
    };
  }

  // View 3D column - also expands when fewer columns
  if (column.key === 'view3D') {
    return {
      width: shouldExpand ? undefined : MIN_WIDTH_VIEW_3D,
      minWidth: MIN_WIDTH_VIEW_3D,
      padding: '0.8rem',
    };
  }

  // Tag Name column
  if (column.key === 'tagName') {
    return {
      width: shouldExpand ? undefined : MIN_WIDTH_TAG_NAME,
      minWidth: MIN_WIDTH_TAG_NAME,
      padding: basePadding,
    };
  }

  // Default columns
  return {
    width: shouldExpand ? undefined : MIN_WIDTH_DEFAULT,
    minWidth: MIN_WIDTH_DEFAULT,
    padding: basePadding,
  };
};
